export default {
  '用户列表':'用户列表',
  '添加':'添加',
  '序号':'序号',
  '用户ID':'用户ID',
  '状态':'状态',
  '启用':'启用',
  '禁用':'禁用',
  '操作':'操作',
  '创建时间':'创建时间',
  '删除成功':'删除成功',
  '编辑':'编辑',
  '用户信息':'用户信息',
  '用户状态：':'用户状态：',
  '模块权限分配':'模块权限分配',
  '请输入姓名':'请输入姓名',
  '请输入电话':'请输入电话',
  '请输入合法手机号/电话号':'请输入合法手机号/电话号',
  '接口错误':'接口错误',
  '授权分配成功':'授权分配成功',
  '授权禁止成功':'授权禁止成功',
  '操作失败，请重试':'操作失败，请重试',
  '操作成功':'操作成功',
  '操作失败':'操作失败',
  '姓名':'姓名',
  '请输入':'请输入'
}